import featureFlagConstants from '~/common/helpers/featureFlagConstants';
import useFeatureFlag from '~/common/hooks/useFeatureFlag';

const { BUILD_EXECUTIONS_TEST_CASES_UX_REVIEW } = featureFlagConstants;

/**
 * Gates the executions and test cases UX review (DST-4648).
 * When off, the canvas keeps the layout it had before that review.
 * Remove this hook, and every `*Legacy` file it selects, once the flag is retired.
 */
export const useExecutionsTestCasesUxReview = () => {
  const { treatments } = useFeatureFlag([
    BUILD_EXECUTIONS_TEST_CASES_UX_REVIEW
  ]);

  return treatments[BUILD_EXECUTIONS_TEST_CASES_UX_REVIEW]?.treatment === 'on';
};
